import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styles from './textFieldPass.module.scss';

export const CustomTextFieldPass = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Form.Group className={styles.formText} controlId={props.controlId}>
            <Form.Label
                className={`${props.classLabel === 'defaultLabel' ? styles.defaultLabel : ''} `}>
                {props.label ? props.label : null}
            </Form.Label>
            <Form.Control
                className={`${props.classType === 'defaultTextBox' ? styles.defaultTextBox : ''}`}
                type={showPassword ? 'text' : 'password'}
                placeholder={props.placeholder}
                onChange={props.handleOnChange}
                name={props.name}
                isInvalid={props.isInvalid}
                value={props.value}
            />
            {!showPassword && (
                <span className={styles.eyeIcon}>
                    <svg onClick={() => setShowPassword(!showPassword)}width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="eye-off">
                            <path id="Icon" d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                    </svg>
                </span>
            )}
            {showPassword && (
                <span className={styles.eyeIcon}>
                    <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M1.61342 8.47546C1.52262 8.3317 1.47723 8.25982 1.45182 8.14895C1.43273 8.06568 1.43273 7.93434 1.45182 7.85107C1.47723 7.7402 1.52262 7.66832 1.61341 7.52456C2.36369 6.33657 4.59693 3.33334 8.00027 3.33334C11.4036 3.33334 13.6369 6.33657 14.3871 7.52456C14.4779 7.66832 14.5233 7.7402 14.5487 7.85107C14.5678 7.93434 14.5678 8.06568 14.5487 8.14895C14.5233 8.25982 14.4779 8.3317 14.3871 8.47546C13.6369 9.66345 11.4036 12.6667 8.00027 12.6667C4.59693 12.6667 2.36369 9.66345 1.61342 8.47546Z" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.00027 10C9.10484 10 10.0003 9.10458 10.0003 8.00001C10.0003 6.89544 9.10484 6.00001 8.00027 6.00001C6.8957 6.00001 6.00027 6.89544 6.00027 8.00001C6.00027 9.10458 6.8957 10 8.00027 10Z" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            )}
            <Form.Control.Feedback type="invalid" id={props.validationMessageId} className={styles.errorMessage}>
                {props.errorMessage}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

CustomTextFieldPass.defaultProps = {
    classLabel: 'defaultLabel',
    classType: 'defaultTextBox'
};